import { combineReducers } from 'redux'
import ChallengeReducer from './ChallengeReducer'
import DomainReducer from './DomainReducer'
import IdeaReducer from './IdeaReducer'
import UserReducer from './UserReducer'
import CreateIdeaReducer from './CreateIdeaReducer'
import ChallengeSteps from './ChallengeStepsReducer'
import UserProfileReducer from './UserProfileReducer'
import RankingReducer from './RankingReducer'
import HowItWorksReducer from './HowItWorksReducer'
import DashboardReducer from './DashboardReducer'
import MaintenanceReducer from './MaintenanceReducer'
import formsReducer from './FormsReducer'

const reducers = combineReducers({
  challenge: ChallengeReducer,
  challengeSteps: ChallengeSteps,
  domain: DomainReducer,
  idea: IdeaReducer,
  user: UserReducer,
  createIdea: CreateIdeaReducer,
  userProfile: UserProfileReducer,
  ranking: RankingReducer,
  howItWorks: HowItWorksReducer,
  dashboard: DashboardReducer,
  maintenance: MaintenanceReducer,
  forms: formsReducer,
})

export default reducers
